import { Alert as RNAlert, Platform } from 'react-native';

export const Alert = msg => {
    if (!msg) {
        return null;
    }

    if (Platform.OS === 'web') {
        window.alert(msg);
    }
    else {
        RNAlert.alert(msg);
    }
};